module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cf65c9399ffb51dfa464d282e3779b93.png";